(function () {
  const SB_URL  = 'https://trizhnqbuuttrmmuioww.supabase.co';
  const SB_KEY  = 'sb_publishable_X3nCRYu4_WojQz7sf525qQ_IDDwLH8c';
  const TABLE   = 'wishlist';
  const LS_KEY  = 'eut_wishlist';
  const VID_KEY = 'eut_visitor_id';

  /* ── Geo ────────────────────────────────────────────────────────────────── */

  const GEO_KEY = 'eut_geo';

  async function getGeo() {
    try {
      const cached = localStorage.getItem(GEO_KEY);
      if (cached) return JSON.parse(cached);
      const res = await fetch('https://ipwho.is/');
      if (!res.ok) return null;
      const d = await res.json();
      const geo = { city: d.city || '', country: d.country_code || '' };
      localStorage.setItem(GEO_KEY, JSON.stringify(geo));
      return geo;
    } catch (e) { return null; }
  }

  /* ── Visitor ID ─────────────────────────────────────────────────────────── */

  function getVisitorId() {
    let id = localStorage.getItem(VID_KEY);
    if (!id) {
      id = crypto.randomUUID ? crypto.randomUUID()
        : 'v-' + Date.now() + '-' + Math.random().toString(36).slice(2);
      localStorage.setItem(VID_KEY, id);
    }
    return id;
  }

  /* ── localStorage ───────────────────────────────────────────────────────── */

  function getLocal() {
    try { return JSON.parse(localStorage.getItem(LS_KEY) || '{}'); }
    catch (e) { return {}; }
  }

  function saveLocal(data) {
    localStorage.setItem(LS_KEY, JSON.stringify(data));
  }

  /* ── Supabase ───────────────────────────────────────────────────────────── */

  function sbHeaders() {
    return {
      'apikey': SB_KEY,
      'Authorization': 'Bearer ' + SB_KEY,
      'Content-Type': 'application/json'
    };
  }

  async function sbAdd(product) {
    try {
      const geo = await getGeo();
      await fetch(SB_URL + '/rest/v1/' + TABLE, {
        method: 'POST',
        headers: Object.assign({ 'Prefer': 'return=minimal' }, sbHeaders()),
        body: JSON.stringify({
          visitor_id:     getVisitorId(),
          product_id:     String(product.id),
          product_handle: product.handle,
          product_title:  product.title,
          product_image:  product.image,
          product_price:  product.price,
          city:           geo ? geo.city : null,
          country:        geo ? geo.country : null
        })
      });
    } catch (e) {}
  }

  async function sbRemove(productId) {
    try {
      await fetch(
        SB_URL + '/rest/v1/' + TABLE +
        '?visitor_id=eq.' + encodeURIComponent(getVisitorId()) +
        '&product_id=eq.' + encodeURIComponent(String(productId)),
        { method: 'DELETE', headers: sbHeaders() }
      );
    } catch (e) {}
  }

  /* ── Hearts ─────────────────────────────────────────────────────────────── */

  function refreshHearts() {
    const wl = getLocal();
    document.querySelectorAll('[data-wishlist-btn]').forEach(btn => {
      const active = !!wl[btn.dataset.productId];
      btn.classList.toggle('is-wishlisted', active);
      btn.setAttribute('aria-pressed', String(active));
      btn.setAttribute('aria-label', active ? 'Retirer de la wishlist' : 'Ajouter à la wishlist');
    });
    refreshBadge();
  }

  function refreshBadge() {
    const count = Object.keys(getLocal()).length;
    document.querySelectorAll('.wishlist-header-badge').forEach(el => {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function toggle(btn) {
    const id = btn.dataset.productId;
    const wl = getLocal();
    if (wl[id]) {
      delete wl[id];
      saveLocal(wl);
      refreshHearts();
      sbRemove(id);
    } else {
      wl[id] = {
        id:     id,
        handle: btn.dataset.productHandle,
        title:  btn.dataset.productTitle,
        image:  btn.dataset.productImage,
        price:  btn.dataset.productPrice
      };
      saveLocal(wl);
      refreshHearts();
      sbAdd(wl[id]);
    }
  }

  /* ── Fetch product data (variants + swatches) ───────────────────────────── */

  async function fetchProduct(handle) {
    try {
      const res = await fetch('/products/' + handle + '.js');
      return res.ok ? res.json() : null;
    } catch (e) { return null; }
  }

  /* ── Wishlist page ──────────────────────────────────────────────────────── */

  async function renderPage() {
    const root = document.getElementById('wishlist-page');
    if (!root) return;

    const items = Object.values(getLocal());

    if (!items.length) {
      root.innerHTML = '<p class="wishlist-page__empty">Votre wishlist est vide pour le moment.<br><a href="/collections/all" class="wishlist-page__shop-link">Découvrir nos bijoux</a></p>';
      return;
    }

    /* Fetch product data for all items in parallel */
    const products = await Promise.all(items.map(item => fetchProduct(item.handle)));

    /* Action bar */
    root.innerHTML = `
      <div class="wishlist-page__actions-bar">
        <button class="wishlist-page__action-btn" id="wl-share">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" width="16" height="16"><path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"/><polyline points="16 6 12 2 8 6"/><line x1="12" y1="2" x2="12" y2="15"/></svg>
          Partager vos coups de coeur
        </button>
        <button class="wishlist-page__action-btn" id="wl-add-all">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" width="16" height="16"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>
          Ajouter vos coups de coeur au panier
        </button>
        <button class="wishlist-page__action-btn wishlist-page__action-btn--danger" id="wl-clear">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" width="16" height="16"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          Supprimer vos coups de coeur
        </button>
      </div>
      <div class="wishlist-page__grid" id="wishlist-grid"></div>
    `;

    const grid = root.querySelector('#wishlist-grid');

    items.forEach((item, i) => {
      const p = products[i];

      /* Detect color option */
      let colorOption = null;
      let colorOptIndex = -1;
      let colors = [];
      let hasColor = false;

      if (p) {
        colorOption = p.options.find(o =>
          ['couleur', 'color', 'colour', 'matière', 'matiere', 'metal', 'métal'].includes(o.name.toLowerCase())
        );
        if (colorOption) {
          colorOptIndex = p.options.indexOf(colorOption);
          colors = [...new Set(p.variants.map(v => v[`option${colorOptIndex + 1}`]))];
          hasColor = colors.length > 1;
        }
      }

      /* First available variant (no color choice needed) */
      const firstVariantId = p ? p.variants[0].id : '';
      const needsColorChoice = hasColor;

      /* Swatches HTML */
      const swatchesHtml = hasColor ? `
        <div class="wishlist-page__swatches">
          <span class="wishlist-page__swatch-label" data-label>Choisir une couleur</span>
          <div class="wishlist-page__swatch-list">
            ${colors.map(c => {
              const variant = p.variants.find(v => v[`option${colorOptIndex + 1}`] === c);
              const { bg, cls } = getSwatchColor(c);
              return `<button class="wishlist-page__swatch${cls ? ' ' + cls : ''}"
                style="${cls ? '' : 'background:' + bg}"
                data-variant="${variant ? variant.id : ''}"
                data-color="${c}"
                title="${c}"></button>`;
            }).join('')}
          </div>
        </div>` : '';

      const card = document.createElement('div');
      card.className = 'wishlist-page__item';
      card.dataset.pid = item.id;
      card.innerHTML = `
        <div class="wishlist-page__figure">
          <div class="wishlist-page__overlay-info">
            <a href="/products/${item.handle}" class="wishlist-page__title">${item.title}</a>
            <p class="wishlist-page__price">${item.price}</p>
          </div>
          <button class="wishlist-page__remove" type="button" data-remove="${item.id}" aria-label="Retirer de la wishlist">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#151515" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="12" height="12"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          </button>
          <a href="/products/${item.handle}" class="wishlist-page__img-link">
            <img src="${item.image || ''}" alt="${item.title}" width="400" height="400" loading="lazy">
          </a>
        </div>
        ${swatchesHtml}
        <button class="button full wishlist-page__atc" type="button"
          data-variant-id="${needsColorChoice ? '' : firstVariantId}"
          data-product-id="${item.id}"
          ${needsColorChoice ? 'disabled' : ''}>
          <span data-content="${needsColorChoice ? 'Choisir une couleur' : 'Ajouter au panier'}"></span>
        </button>
      `;
      grid.appendChild(card);
    });

    /* Remove single item */
    grid.querySelectorAll('[data-remove]').forEach(btn => {
      btn.addEventListener('click', () => {
        const pid = btn.dataset.remove;
        removeItem(pid);
        btn.closest('.wishlist-page__item').remove();
        if (!Object.keys(getLocal()).length) renderPage();
        else refreshBadge();
      });
    });

    /* Swatch selection */
    grid.querySelectorAll('.wishlist-page__swatch').forEach(sw => {
      sw.addEventListener('click', () => {
        const card = sw.closest('.wishlist-page__item');
        card.querySelectorAll('.wishlist-page__swatch').forEach(s => s.classList.remove('active'));
        sw.classList.add('active');
        const atcBtn = card.querySelector('.wishlist-page__atc');
        const label = card.querySelector('[data-label]');
        if (atcBtn && sw.dataset.variant) {
          atcBtn.dataset.variantId = sw.dataset.variant;
          atcBtn.disabled = false;
          setAtcText(atcBtn, 'Ajouter au panier');
        }
        if (label) label.textContent = sw.dataset.color;
      });
    });

    /* ATC single */
    grid.querySelectorAll('.wishlist-page__atc').forEach(btn => {
      btn.addEventListener('click', () => addToCart(btn.dataset.variantId, btn));
    });

    /* Action bar */
    document.getElementById('wl-share').addEventListener('click', shareWishlist);
    document.getElementById('wl-add-all').addEventListener('click', addAllToCart);
    document.getElementById('wl-clear').addEventListener('click', clearWishlist);
  }

  /* ── Cart ───────────────────────────────────────────────────────────────── */

  function setAtcText(btn, text) {
    const span = btn.querySelector('span');
    if (span) { span.dataset.content = text; }
    else btn.textContent = text;
  }

  async function addToCart(variantId, btn) {
    if (!variantId) return;
    const span = btn.querySelector('span');
    const orig = span ? span.textContent : btn.textContent;
    setAtcText(btn, '...');
    btn.disabled = true;
    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });
      setAtcText(btn, 'Ajouté ✓');
      setTimeout(() => { setAtcText(btn, orig); btn.disabled = false; }, 2000);
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    } catch (e) {
      setAtcText(btn, orig);
      btn.disabled = false;
    }
  }

  async function addAllToCart() {
    const btn = document.getElementById('wl-add-all');
    const items = Object.values(getLocal());
    if (!items.length) return;
    btn.textContent = '...';
    btn.disabled = true;
    const products = await Promise.all(items.map(i => fetchProduct(i.handle)));
    const items_payload = products
      .filter(Boolean)
      .map(p => ({ id: p.variants[0].id, quantity: 1 }));
    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items_payload })
      });
      btn.textContent = 'Tous ajoutés ✓';
      setTimeout(() => { btn.textContent = 'Ajouter vos coups de coeur au panier'; btn.disabled = false; }, 2000);
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    } catch (e) {
      btn.textContent = 'Ajouter vos coups de coeur au panier';
      btn.disabled = false;
    }
  }

  /* ── Share ──────────────────────────────────────────────────────────────── */

  function shareWishlist() {
    navigator.clipboard.writeText(window.location.href).then(() => {
      const btn = document.getElementById('wl-share');
      btn.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" width="16" height="16"><path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"/><polyline points="16 6 12 2 8 6"/><line x1="12" y1="2" x2="12" y2="15"/></svg> Lien copié !`;
    });
  }

  /* ── Clear all ──────────────────────────────────────────────────────────── */

  function clearWishlist() {
    if (!confirm('Supprimer tous vos coups de coeur ?')) return;
    const wl = getLocal();
    Object.keys(wl).forEach(id => sbRemove(id));
    saveLocal({});
    refreshHearts();
    renderPage();
  }

  function removeItem(pid) {
    const wl = getLocal();
    delete wl[pid];
    saveLocal(wl);
    sbRemove(pid);
    refreshHearts();
  }

  /* ── Swatch color helper ─────────────────────────────────────────────────── */

  function getSwatchColor(name) {
    const n = name.toLowerCase();
    const goldNames = ['or', 'gold', 'doré', 'dore', 'or jaune'];
    const silverNames = ['argent', 'silver', 'argenté', 'argente'];
    if (goldNames.includes(n)) return { bg: '', cls: 'eut-swatch-gold' };
    if (silverNames.includes(n)) return { bg: '', cls: 'eut-swatch-silver' };
    const map = {
      'blanc': '#FFFFFF', 'white': '#FFFFFF',
      'noir': '#151515', 'black': '#151515',
      'rose': '#F4A7B9', 'pink': '#F4A7B9',
      'or rose': '#E8A090', 'rose gold': '#E8A090',
    };
    return { bg: map[n] || '#e0e0e0', cls: '' };
  }

  /* ── Init ───────────────────────────────────────────────────────────────── */

  document.addEventListener('click', e => {
    const btn = e.target.closest('[data-wishlist-btn]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    toggle(btn);
  });

  document.addEventListener('DOMContentLoaded', () => {
    refreshHearts();
    renderPage();
  });

})();
